import { useState, useEffect } from 'react';
// import { officesMockData } from '../../data/offices';
import { API, CMSAPI } from '../../services/index';
import { SessionStorage } from '../storage';
import { Office } from './use-cities';


type OfficeResponse = Array<Office>;

const OFFICES_KEY = 'offices';

export const useOffices = () => {
  const [offices, setOffices] = useState<OfficeResponse>([]);

  useEffect(() => {
    // Check if sessionstorage has offices otherwise fetch the offices
    if (!SessionStorage.get(OFFICES_KEY)) {
      fetchOffices();
    } else {
      setOffices(SessionStorage.get(OFFICES_KEY) as OfficeResponse);
    }
  }, []);

  const fetchOffices = () => {
    // Use mockFetchOffices during development only (also dont forget to comment offcesMockData when merging or deploying to acc or prod)
    // mockFetchOffices()
    CMSAPI.get<OfficeResponse>(`offices/`)
      .then((res) => {
        const transformedOffices = orderOfficesByName(res);
        SessionStorage.set(OFFICES_KEY, transformedOffices);
        setOffices(res);
      })
      .catch((err) => {
        console.log(err);
        setOffices([]);
      });
  };

  const fetchOfficeByZipcode = (zipcode: string) => {
    // Use mockFetchOffices during development only (also dont forget to comment offcesMockData when merging or deploying to acc or prod)
    // mockFetchOffices()
    return new Promise<OfficeResponse>((resolve, reject) => {
      CMSAPI.get<OfficeResponse>(`offices/near?location=${zipcode}`)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          console.log(err);
          resolve([])
        });
    });
  }

  const fetchOfficeById = (officeId: string) => {
    // Use mockFetchOffices during development only (also dont forget to comment offcesMockData when merging or deploying to acc or prod)
    // mockFetchOffices()
    return new Promise<Office | null>((resolve, reject) => {
      API.get<Office>(`office/getbyinternalid?id=${officeId}`)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          console.log(err);
          resolve(null)
        });
    });
  }

  return {
    offices,
    officesFilteredBySearchterm: mapOfficesToSearchterm(offices),
    fetchOffices,
    fetchOfficeByZipcode,
    fetchOfficeById
  };
};

// The office API is not working locally so we made a mockAPI only import officesMockData when developing locally.
// export const mockFetchOffices = () => {
//     return new Promise<OfficeResponse>((res) => {
//         setTimeout(() => {
//             res(officesMockData as OfficeResponse);
//         }, 1000);
//     });
// };

export function orderOfficesByName(offices: OfficeResponse) {
  return offices.sort((a, b) => a.fullName.localeCompare(b.fullName));
}

export function mapOfficesToSearchterm(offices: OfficeResponse) {
  return offices.map((office) => ({searchterm: office.fullName}));
}

